import { Container, Grid, Typography, Paper, Box, useTheme, Stack, IconButton } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getPlantList } from "../../store/actions/PlantActions";
import { getTechnicianList } from "../../store/actions/userActions";
import { getBreakdownReasonGroupList } from "../../store/actions/ReportBreakDownActions";
import {
    getOperatorFiveWsOneHAnalysis,
    getRootCauseFamilies,
    postEwoFormFileWithEwoId,
    postEwoFormCreateWithFile,
    postEwoFormCreateWithOperatorFields,
    getOperatorFieldsByTaskId,
    getEwoFormDetailById,
} from "../../store/actions/EwoActions";
import { getRootCauseFamilyAndOptions } from "../../store/actions/RootCauseFamilyAndOptionsAction";
import { blue } from "@mui/material/colors";
import * as queryString from "query-string";
import JSZip from "jszip";
import "./printStyles.css";
import Header from "./Header";
import EquipmentInfo from "./EquipmentInfo";
import RecordOfIntervention from "./RecordOfIntervention";
import FiveWOneHAnalysis from "./FiveWOneHAnalysis";
import ListOfPossibleCauses from "./ListOfPossibleCauses";
import VerificationOfPossibleCauses from "./VerificationOfPossibleCauses";
import FiveWhysAnalysis from "./FiveWhysAnalysis";
import RootCausesFamiliesForm from "./RootCausesFamilies";
import Footer from "./Footer";
import Buttons from "./Buttons";
import { getToDraftsByTaskId, deleteToDraftsByTaskId, postAddEwoFormToDrafts, getEwoFormFileByTaskId, deleteEwoFromFileByEwoId, getFormDetailById, getFormDetail } from "../../api/EwoApi";

const useStyles = makeStyles((theme) => ({
    customLabel: {
        fontSize: "13px", // Adjust the font size as needed
        paddingTop: 1,
    },
    resize: {
        fontSize: 13,
    },
    root: {
        "& .MuiFormControl-root": {
            margin: 0,
        },
    },
    select: {
        "&:before": {
            borderColor: blue,
        },
        "&:after": {
            borderColor: "#008000",
        },
    },
}));

export default function EwoForm(props) {
    const pageStyle = "@page { size: A4 portrait }";
    const { t } = useTranslation("translation");
    const theme = useTheme();
    let componentRef = useRef();
    const location = useLocation();
    const dispatch = useDispatch();
    const fromPage = queryString.parse(window.location.search).from;
    const res = useSelector(({ ReportBreakDown }) => ReportBreakDown);
    const isEdit = location.state?.isEdit ?? false;
    const ewoId = location.state?.ewoId;

    const history = useHistory();
    const [shouldBlockNavigation, setShouldBlockNavigation] = useState(true);

    //ERROR STATES//
    const [hasTechinicianError, setHasTechinicianError] = useState(true);
    const [technicianErrorText, setTechnicianErrorText] = useState(t("EmptyCheck"));
    const [hasWaitMinError, setHasWaitMinError] = useState(true);
    const [waitMinErrorText, setWaitMinErrorText] = useState(t("EmptyCheck"));
    const [hasDiagnosisMinError, setHasDiagnosisMinError] = useState(true);
    const [diagnosisMinErrorText, setDiagnosisMinErrorText] = useState(t("EmptyCheck"));
    const [hasSpSearchMinError, setHasSpSearchMinError] = useState(true);
    const [spSearchMinErrorText, setSpSearchMinErrorText] = useState(t("EmptyCheck"));
    const [hasRepairingMinError, setHasRepairingMinError] = useState(true);
    const [repairingMinErrorText, setRepairingMinErrorText] = useState(t("EmptyCheck"));
    const [hasStartUpMinError, setHasStartUpMinError] = useState(true);
    const [startUpMinErrorText, setStartUpMinErrorText] = useState(t("EmptyCheck"));
    const [hasBreakdownGroupError, setHasBreakdownGroupError] = useState(true);
    const [breakdownGroupErrorText, setBreakdownGroupErrorText] = useState(t("EmptyCheck"));
    const [hasWhatError, setHasWhatError] = useState(true);
    const [whatErrorText, setWhatErrorText] = useState(t("EmptyCheck"));
    const [hasWhereError, setHasWhereError] = useState(true);
    const [whereErrorText, setWhereErrorText] = useState(t("EmptyCheck"));
    const [hasWhoError, setHasWhoError] = useState(true);
    const [whoErrorText, setWhoErrorText] = useState(t("EmptyCheck"));
    const [hasWhichError, setHasWhichError] = useState(true);
    const [whichErrorText, setWhichErrorText] = useState(t("EmptyCheck"));
    const [hasHowError, setHasHowError] = useState(true);
    const [howErrorText, setHowErrorText] = useState(t("EmptyCheck"));
    const [hasDescriptionError, setHasDescriptionError] = useState(true);
    const [descriptionErrorText, setDescriptionErrorText] = useState(t("EmptyCheck"));
    const [hasCauseAError, setHasCauseAError] = useState(true);
    const [causeAErrorText, setCauseAErrorText] = useState(t("EmptyCheck"));
    const [hasPossibleCauseAError, setHasPossibleCauseAError] = useState(true);
    const [possibleCauseAErrorText, setPossibleCauseAErrorText] = useState(t("EmptyCheck"));
    const [hasHypothesis1_1Error, setHasHypothesis1_1Error] = useState(true);
    const [hypothesis1_1ErrorText, setHypothesis1_1ErrorText] = useState(t("EmptyCheck"));
    const [hasExecutedError, setHasExecutedError] = useState(true);
    const [executedErrorText, setExecutedErrorText] = useState(t("EmptyCheck"));
    const [hasVerifiedError, setHasVerifiedError] = useState(true);
    const [verifiedErrorText, setVerifiedErrorText] = useState(t("EmptyCheck"));
    const [hasEwoCreatedDateError, setHasEwoCreatedDateError] = useState(true);
    const [ewoCreatedDateErrorText, setEwoCreatedDateErrorText] = useState(t("EmptyCheck"));
    const [hasSignatureError, setHasSignatureError] = useState(true);
    const [signatureErrorText, setSignatureErrorText] = useState(t("MustBeOk"));
    const [hasClosureDateError, setHasClosureDateError] = useState(true);
    const [closureDateErrorText, setClosureDateErrorText] = useState(t("EmptyCheck"));
    const [hasWhenError, setHasWhenError] = useState(true);

    //FIRST STATES//
    const [ewocode, setEwoCode] = useState("");
    const [techData, setTechData] = useState([]);
    const [ewoCreatedDate, setEwoCreatedDate] = useState(new Date(""));
    const [closureDate, setClosureDate] = useState(new Date(""));
    const [equipmentTitleName, setEquipmentTitleName] = useState("");

    // RECORD OF INTERVENTION STATES //
    const [taskCreatedDate, setTaskCreatedDate] = useState(new Date(""));
    const [waitMin, setWaitMin] = useState();
    const [diagnosisMin, setDiagnosisMin] = useState();
    const [spSearchMin, setSpSearchMin] = useState();
    const [repairingMin, setRepairingMin] = useState();
    const [startUpMin, setStartUpMin] = useState();
    const [interventionEndedDate, setInterventionEndedDate] = useState(new Date(""));
    const [breakdownGroupData, setBreakdownGroupData] = useState([]);
    const [breakdownGroupId, setBreakdownGroupId] = useState();
    const [breakdownReasonGroupName, setBreakdownReasonGroupName] = useState();

    // 5W + 1H ANALYSIS STATES //
    const [what, setWhat] = useState("");
    const [where, setWhere] = useState("");
    const [who, setWho] = useState("");
    const [which, setWhich] = useState("");
    const [how, setHow] = useState("");

    //DESCRIPTION OF ACTIVITIES//
    const [descriptionOfActivities, setDescriptionOfActivities] = useState("");

    // LIST OF POSSIBLE CAUSES STATES //
    const [causeA, setCauseA] = useState("");
    const [causeB, setCauseB] = useState("");
    const [causeC, setCauseC] = useState("");

    // VERIFICATION OF POSSIBLE CAUSES STATES //
    const [possibleCauseA, setPossibleCauseA] = useState("");
    const [possibleCauseB, setPossibleCauseB] = useState("");
    const [possibleCauseC, setPossibleCauseC] = useState("");
    const [possibleCauseAStatus, setPossibleCauseAStatus] = useState(false);
    const [possibleCauseBStatus, setPossibleCauseBStatus] = useState(false);
    const [possibleCauseCStatus, setPossibleCauseCStatus] = useState(false);

    // 5WHYS ANALYSIS STATES //
    const [hypothesis1_1, setHypothesis1_1] = useState("");
    const [hypothesis1_2, setHypothesis1_2] = useState("");
    const [hypothesis1_3, setHypothesis1_3] = useState("");
    const [hypothesis1_4, setHypothesis1_4] = useState("");

    const [hypothesis2_1, setHypothesis2_1] = useState("");
    const [hypothesis2_2, setHypothesis2_2] = useState("");
    const [hypothesis2_3, setHypothesis2_3] = useState("");
    const [hypothesis2_4, setHypothesis2_4] = useState("");

    const [hypothesis3_1, setHypothesis3_1] = useState("");
    const [hypothesis3_2, setHypothesis3_2] = useState("");
    const [hypothesis3_3, setHypothesis3_3] = useState("");
    const [hypothesis3_4, setHypothesis3_4] = useState("");

    const [hypothesis4_1, setHypothesis4_1] = useState("");
    const [hypothesis4_2, setHypothesis4_2] = useState("");
    const [hypothesis4_3, setHypothesis4_3] = useState("");
    const [hypothesis4_4, setHypothesis4_4] = useState("");

    const [hypothesis5_1, setHypothesis5_1] = useState("");
    const [hypothesis5_2, setHypothesis5_2] = useState("");
    const [hypothesis5_3, setHypothesis5_3] = useState("");
    const [hypothesis5_4, setHypothesis5_4] = useState("");

    // COUNTERMASSURES STATES //
    const [a1What, setA1What] = useState("");
    const [a1Who, setA1Who] = useState("");
    const [a1When, setA1When] = useState(new Date(""));
    const [a2What, setA2What] = useState("");
    const [a2Who, setA2Who] = useState("");
    const [a2When, setA2When] = useState(new Date(""));
    const [a3What, setA3What] = useState("");
    const [a3Who, setA3Who] = useState("");
    const [a3When, setA3When] = useState(new Date(""));
    const [a4What, setA4What] = useState("");
    const [a4Who, setA4Who] = useState("");
    const [a4When, setA4When] = useState(new Date(""));

    const [amWhat, setAmWhat] = useState("");
    const [amWho, setAmWho] = useState("");
    const [amWhen, setAmWhen] = useState(new Date(""));
    const [ftWhat, setFtWhat] = useState("");
    const [ftWho, setFtWho] = useState("");
    const [ftWhen, setFtWhen] = useState(new Date(""));
    const [smWhat, setSmWhat] = useState("");
    const [smWho, setSmWho] = useState("");
    const [smWhen, setSmWhen] = useState(new Date(""));
    const [pmWhat, setPmWhat] = useState("");
    const [pmWho, setPmWho] = useState("");
    const [pmWhen, setPmWhen] = useState(new Date(""));
    const [drWhat, setDrWhat] = useState("");
    const [drWho, setDrWho] = useState("");
    const [drWhen, setDrWhen] = useState(new Date(""));
    const [asWhat, setAsWhat] = useState("");
    const [asWho, setAsWho] = useState("");
    const [asWhen, setAsWhen] = useState(new Date(""));
    const [plWhat, setPlWhat] = useState("");
    const [plWho, setPlWho] = useState("");
    const [plWhen, setPlWhen] = useState(new Date(""));

    const [executedTechnicianId, setExecutedTechnicianId] = useState("");
    const [executedTechnicianName, setExecutedTechnicianName] = useState("");
    const [verifiedTechnicianId, setVerifiedTechnicianId] = useState("");
    const [verifiedTechnicianName, setVerifiedTechnicianName] = useState("");
    const [signature, setSignature] = useState(false);

    //STATES//

    const [maintenanceOperatorsName, setMaintenanceOperatorsName] = useState("");
    const [maintenanceOperatorsId, setMaintenanceOperatorsId] = useState("");
    const [plantName, setPlantName] = useState("");
    const [mainEquipmentCode, setMainEquipmentCode] = useState("");
    const [mainEquipmentId, setMainEquipmentId] = useState("");
    const [plantId, setPlantId] = useState();
    const [equipmentName, setEquipmentName] = useState("");
    const [equipmentId, setEquipmentId] = useState("");
    const [technicianIds, setTechnicianIds] = useState([{ userId: 0 }]);
    const [technicianNames, setTechnicianNames] = useState([]);
    const [isSaveDisable, setIsSaveDisable] = useState(true);
    const [isCancelDisable, setIsCancelDisable] = useState(false);
    const [isOperatorDisable, setIsOperatorDisable] = useState(false);

    // ROOT CAUSE FAMILIES STATES //
    const [lackOfBasicConditions, setLackOfBasicConditions] = useState([]);
    const [failureToRespect, setFailureToRespect] = useState([]);
    const [lackOfMaintenance, setLackOfMaintenance] = useState([]);
    const [insufficientSkills, setInsufficientSkills] = useState([]);
    const [designWeaknesses, setDesignWeaknesses] = useState([]);
    const [externalInfluences, setExternalInfluences] = useState([]);
    const [rootCauseFamilyRelationId, setRootCauseFamilyRelationId] = useState(0);

    const [selectedLackOfCondition, setSelectedLackOfCondition] = useState(0);
    const [selectedFailureToRespect, setSelectedFailureToRespect] = useState(0);
    const [selectedLackOfMaintenance, setSelectedLackOfMaintenance] = useState(0);
    const [selectedInsufficientSkills, setSelectedInsufficientSkills] = useState(0);
    const [selectedDesignWeaknesses, setSelectedDesignWeaknesses] = useState(0);
    const [selectedExternalInfluences, setSelectedExternalInfluences] = useState(0);

    const [rootCauseFamilyAndOptionsState, setRootCauseFamilyAndOptionsState] = useState([]);
    const [operatorFiveWsOneHAnalysis, setOperatorFiveWsOneHAnalysis] = useState([]);

    const [operatorTaskId, setOperatorTaskId] = useState(null);

    const [blobFile, setBlobFile] = useState([]);
    const [images, setImages] = React.useState([]);

    const [draft, setDraft] = useState();
    const skipDraftSave = useRef(false);

    const { plant } = useSelector((plant) => plant);
    const { ewoForm } = useSelector((state) => state);
    const { rootCauseFamilyAndOptions } = useSelector((state) => state);
    const [rootCauseFamilyId, setRootCauseFamilyId] = useState();
    const photoUploaded = useRef(false);
    const initialDisableStates = {
        isMaintenanceOperatorDisabled: false,
        isPlantDisable: false,
        isLineDisable: false,
        isEquipmentDisable: false,
        isDateDisable: false,
        isEwoCodeDisable: false,
        isWaitDisable: false,
        isDiagnosisDisable: false,
        isSpSearchDisable: false,
        isRepairingDisable: false,
        isStartupDisable: false,
        isInterventionDateDisable: false,
        isBreakdownGroupDisable: false,
        isWhatDisable: false,
        isWhereDisable: false,
        isWhoDisable: false,
        isWhichDisable: false,
        isWhichRadioDisable: false,
        isHowDisable: false,
        isWhenDisable: false,
        isDescriptionOfActivitiesDisable: false,
        isCauseADisable: false,
        isCauseBDisable: false,
        isCauseCDisable: false,
        isPossibleCauseADisable: false,
        isPossibleCauseBDisable: false,
        isPossibleCauseCDisable: false,
        isPossibleCauseAStatusDisable: false,
        isPossibleCauseBStatusDisable: false,
        isPossibleCauseCStatusDisable: false,
        isHypothesis1_1Disable: false,
        isHypothesis1_2Disable: false,
        isHypothesis1_3Disable: false,
        isHypothesis1_4Disable: false,
        isHypothesis2_1Disable: false,
        isHypothesis2_2Disable: false,
        isHypothesis2_3Disable: false,
        isHypothesis2_4Disable: false,
        isHypothesis3_1Disable: false,
        isHypothesis3_2Disable: false,
        isHypothesis3_3Disable: false,
        isHypothesis3_4Disable: false,
        isHypothesis4_1Disable: false,
        isHypothesis4_2Disable: false,
        isHypothesis4_3Disable: false,
        isHypothesis4_4Disable: false,
        isHypothesis5_1Disable: false,
        isHypothesis5_2Disable: false,
        isHypothesis5_3Disable: false,
        isHypothesis5_4Disable: false,
        isA1WhatDisable: false,
        isA1WhoDisable: false,
        isA1WhenDisable: false,
        isA2WhatDisable: false,
        isA2WhoDisable: false,
        isA2WhenDisable: false,
        isA3WhatDisable: false,
        isA3WhoDisable: false,
        isA3WhenDisable: false,
        isA4WhatDisable: false,
        isA4WhoDisable: false,
        isA4WhenDisable: false,
        isAmWhatDisable: false,
        isAmWhoDisable: false,
        isAmWhenDisable: false,
        isFtWhatDisable: false,
        isFtWhoDisable: false,
        isFtWhenDisable: false,
        isSmWhatDisable: false,
        isSmWhoDisable: false,
        isSmWhenDisable: false,
        isPmWhatDisable: false,
        isPmWhoDisable: false,
        isPmWhenDisable: false,
        isDrWhatDisable: false,
        isDrWhoDisable: false,
        isDrWhenDisable: false,
        isAsWhatDisable: false,
        isAsWhoDisable: false,
        isAsWhenDisable: false,
        isPlWhatDisable: false,
        isPlWhoDisable: false,
        isPlWhenDisable: false,
        isExecutedDisable: false,
        isVerifiedDisable: false,
        isSignatureDisable: false,
        isClosureDateDisable: false,
    };

    const [disableStates, setDisableStates] = useState(initialDisableStates);

    const [formDetail, setFormDetail] = useState(null);
    useEffect(() => {
        const id = queryString.parse(window.location.search).id;
        if (fromPage === "list") {
            setIsOperatorDisable(true);
            dispatch(getEwoFormDetailById(id));
            //burada ilgili ewo forma ait foto da çekilecek
        } else if (fromPage === "detail") {
            setIsOperatorDisable(true);
        }

        loadHandler();
        dispatch(getTechnicianList());
        dispatch(getBreakdownReasonGroupList());
        dispatch(getRootCauseFamilies());
        dispatch(getOperatorFiveWsOneHAnalysis());
    }, []);

    useEffect(() => {
        if (fromPage === "detail") {
            const fetchData = async () => {
                const response = await getFormDetail(ewoId);
                if (response.data != null) {
                    setFormDetail(response?.data?.ewoForm);
                }
            }

            fetchData();
        }
    }, []);


    const taskId = queryString.parse(window.location.search).id;
    useEffect(() => {
        const fetchData = async () => {
            const taskId = queryString.parse(window.location.search).id;
            const response = await getToDraftsByTaskId(taskId);
            if (response.data != null) {
                setDraft(response.data.resultObject);
            }
        };

        fetchData();
    }, []);

    const fetchZipAndExtractImage = async (zipBlob) => {
        try {
            const zip = await JSZip.loadAsync(zipBlob);
            const fileNames = Object.keys(zip.files);

            if (fileNames.length === 0) {
                console.error("Zip file is empty!");
                return;
            }

            const firstFile = zip.files[fileNames[0]];
            const base64Data = await firstFile.async("base64");

            const extension = fileNames[0].split(".").pop().toLowerCase();
            let mimeType = "image/png";
            if (extension === "jpg" || extension === "jpeg") mimeType = "image/jpeg";
            else if (extension === "gif") mimeType = "image/gif";

            const dataUrl = `data:${mimeType};base64,${base64Data}`;
            return dataUrl;
        } catch (error) {
            console.error("Error extracting zip file: ", error);
        }
    };

    const blobResponse = useRef();
    useEffect(async () => {
        if (fromPage === "detail" && draft && draft.isPhotoUploaded && !isEdit) {
            const response = await getEwoFormFileByTaskId(location.state?.data.emergencyWorkOrderId);
            const dataUrl = await fetchZipAndExtractImage(response.data);
            photoUploaded.current = true;
            blobResponse.current = response.data;
            setImages([{ data_url: dataUrl }]);
        }
    }, [draft]);

    useEffect(async () => {
        if (fromPage === "detail" && isEdit) {
            const response = await getEwoFormFileByTaskId(location.state?.data.emergencyWorkOrderId);
            const dataUrl = await fetchZipAndExtractImage(response.data);
            photoUploaded.current = true;
            blobResponse.current = response.data;
            setImages([{ data_url: dataUrl }]);
            setBlobFile(blobResponse.current);
        }
    }, [])

    const parseForm = (data) => {
        if (data?.date != null) {
            setEwoCreatedDate(new Date(data.date));
            setEwoCreatedDateErrorText("");
            setHasEwoCreatedDateError(false);
        }
        if (data?.closureDate != null) {
            setClosureDate(new Date(data.closureDate));
            setClosureDateErrorText("");
            setHasClosureDateError(false);
        }
        if (data?.userEmergencyWorkOrder[0]?.userId != 0) {
            //bakim operatorleri
            const idList = new Set(data?.userEmergencyWorkOrder?.map((x) => x.userId));
            const names = technicianList?.filter((x) => idList.has(x.id));
            setTechnicianNames(names);
            setTechnicianErrorText("");
            setHasTechinicianError(false);
            const result = [...idList]?.map((userId) => ({ userId }));
            setTechnicianIds(result);
        }
        if (data?.signature) {
            setSignature(data?.signature);
            setSignatureErrorText("");
            setHasSignatureError(false);
        }
        if (data?.recordOfIntervention?.breakdownGroupId != -1) {
            const breakdownId = data?.recordOfIntervention.breakdownGroupId;
            const breakdownName = breakdownGroupData?.filter((x) => x.id == breakdownId);
            setBreakdownGroupId(breakdownId);
            setBreakdownReasonGroupName(breakdownName[0]?.breakdownReasonGroupLocalizationName);
            setHasBreakdownGroupError(false);
            setBreakdownGroupErrorText("");
        }
        if (data?.recordOfIntervention?.wait != 0) {
            setWaitMin(data?.recordOfIntervention?.wait);
            setHasWaitMinError(false);
            setWaitMinErrorText("");
        }
        if (data?.recordOfIntervention?.diagnosis > 0) {
            setDiagnosisMin(data?.recordOfIntervention?.diagnosis);
            setDiagnosisMinErrorText("");
            setHasDiagnosisMinError(false);
        }
        if (data?.recordOfIntervention?.repairing > 0) {
            setRepairingMin(data?.recordOfIntervention?.repairing);
            setRepairingMinErrorText("");
            setHasRepairingMinError(false);
        }
        if (data?.recordOfIntervention?.startUp > 0) {
            setStartUpMin(data?.recordOfIntervention?.startUp);
            setStartUpMinErrorText("");
            setHasStartUpMinError(false);
        }
        if (data?.recordOfIntervention?.sparePartSearch > 0) {
            setSpSearchMin(data?.recordOfIntervention?.sparePartSearch);
            setSpSearchMinErrorText("");
            setHasSpSearchMinError(false);
        }
        if (data?.descriptionOfActivity != "") {
            setDescriptionOfActivities(data?.descriptionOfActivity);
            setDescriptionErrorText("");
            setHasDescriptionError(false);
        }
        if (data?.listOfPossibleCause?.causeA != "") {
            setCauseA(data?.listOfPossibleCause?.causeA);
            setCauseAErrorText("");
            setHasCauseAError(false);
        }
        if (data?.listOfPossibleCause?.causeB != "") {
            setCauseB(data?.listOfPossibleCause?.causeB);
        }
        if (data?.listOfPossibleCause?.causeC != "") {
            setCauseC(data?.listOfPossibleCause?.causeC);
        }
        if (data?.verificationOfPossibleCause?.causeA != "") {
            setPossibleCauseA(data?.verificationOfPossibleCause?.causeA);
            setPossibleCauseAErrorText("");
            setHasPossibleCauseAError(false);
            setPossibleCauseAStatus(data?.verificationOfPossibleCause?.causeAStatus);
        }
        if (data?.verificationOfPossibleCause?.causeB) {
            setPossibleCauseB(data?.verificationOfPossibleCause?.causeB);
            setPossibleCauseBStatus(data?.verificationOfPossibleCause?.causeBStatus);
        }
        if (data?.verificationOfPossibleCause?.causeC) {
            setPossibleCauseC(data?.verificationOfPossibleCause?.causeC);
            setPossibleCauseCStatus(data?.verificationOfPossibleCause?.causeCStatus);
        }
        //hypo_1
        if (data?.technicianFiveWsOneHAnalysis[0]?.hypothesis1 != "") {
            setHypothesis1_1(data?.technicianFiveWsOneHAnalysis[0]?.hypothesis1);
            setHypothesis1_1ErrorText("");
            setHasHypothesis1_1Error(false);
        }
        if (data?.technicianFiveWsOneHAnalysis[0]?.hypothesis2 != "") {
            setHypothesis1_2(data?.technicianFiveWsOneHAnalysis[0]?.hypothesis2);
        }
        if (data?.technicianFiveWsOneHAnalysis[0]?.hypothesis3 != "") {
            setHypothesis1_3(data?.technicianFiveWsOneHAnalysis[0]?.hypothesis3);
        }
        if (data?.technicianFiveWsOneHAnalysis[0]?.hypothesis4 != "") {
            setHypothesis1_4(data?.technicianFiveWsOneHAnalysis[0]?.hypothesis4);
        }
        //hypo_2
        if (data?.technicianFiveWsOneHAnalysis[1]?.hypothesis1 != "") {
            setHypothesis2_1(data?.technicianFiveWsOneHAnalysis[1]?.hypothesis1);
        }
        if (data?.technicianFiveWsOneHAnalysis[1]?.hypothesis2 != "") {
            setHypothesis2_2(data?.technicianFiveWsOneHAnalysis[1]?.hypothesis2);
        }
        if (data?.technicianFiveWsOneHAnalysis[1]?.hypothesis3 != "") {
            setHypothesis2_3(data?.technicianFiveWsOneHAnalysis[1]?.hypothesis3);
        }
        if (data?.technicianFiveWsOneHAnalysis[1]?.hypothesis4 != "") {
            setHypothesis2_4(data?.technicianFiveWsOneHAnalysis[1]?.hypothesis4);
        }
        //hypo_3
        if (data?.technicianFiveWsOneHAnalysis[2]?.hypothesis1 != "") {
            setHypothesis3_1(data?.technicianFiveWsOneHAnalysis[2]?.hypothesis1);
        }
        if (data?.technicianFiveWsOneHAnalysis[2]?.hypothesis2 != "") {
            setHypothesis3_2(data?.technicianFiveWsOneHAnalysis[2]?.hypothesis2);
        }
        if (data?.technicianFiveWsOneHAnalysis[2]?.hypothesis3 != "") {
            setHypothesis3_3(data?.technicianFiveWsOneHAnalysis[2]?.hypothesis3);
        }
        if (data?.technicianFiveWsOneHAnalysis[2]?.hypothesis4 != "") {
            setHypothesis3_4(data?.technicianFiveWsOneHAnalysis[2]?.hypothesis4);
        }
        //hypo_4
        if (data?.technicianFiveWsOneHAnalysis[3]?.hypothesis1 != "") {
            setHypothesis4_1(data?.technicianFiveWsOneHAnalysis[3]?.hypothesis1);
        }
        if (data?.technicianFiveWsOneHAnalysis[3]?.hypothesis2 != "") {
            setHypothesis4_2(data?.technicianFiveWsOneHAnalysis[3]?.hypothesis2);
        }
        if (data?.technicianFiveWsOneHAnalysis[3]?.hypothesis3 != "") {
            setHypothesis4_3(data?.technicianFiveWsOneHAnalysis[3]?.hypothesis3);
        }
        if (data?.technicianFiveWsOneHAnalysis[3]?.hypothesis4 != "") {
            setHypothesis4_4(data?.technicianFiveWsOneHAnalysis[3]?.hypothesis4);
        }
        //hypo_5
        if (data?.technicianFiveWsOneHAnalysis[4]?.hypothesis1 != "") {
            setHypothesis5_1(data?.technicianFiveWsOneHAnalysis[4]?.hypothesis1);
        }
        if (data?.technicianFiveWsOneHAnalysis[4]?.hypothesis2 != "") {
            setHypothesis5_2(data?.technicianFiveWsOneHAnalysis[4]?.hypothesis2);
        }
        if (data?.technicianFiveWsOneHAnalysis[4]?.hypothesis3 != "") {
            setHypothesis5_3(data?.technicianFiveWsOneHAnalysis[4]?.hypothesis3);
        }
        if (data?.technicianFiveWsOneHAnalysis[4]?.hypothesis4 != "") {
            setHypothesis5_4(data?.technicianFiveWsOneHAnalysis[4]?.hypothesis4);
        }
        //a1
        if (data?.technicianCountermeasure[0]?.what != "") {
            setA1What(data?.technicianCountermeasure[0]?.what);
        }
        if (data?.technicianCountermeasure[0]?.who != "") {
            setA1Who(data?.technicianCountermeasure[0]?.who);
        }
        if (data?.technicianCountermeasure[0]?.when != null) {
            setA1When(new Date(data?.technicianCountermeasure[0]?.when));
        }
        //a2
        if (data?.technicianCountermeasure[1]?.what != "") {
            setA2What(data?.technicianCountermeasure[1]?.what);
        }
        if (data?.technicianCountermeasure[1]?.who != "") {
            setA2Who(data?.technicianCountermeasure[1]?.who);
        }
        if (data?.technicianCountermeasure[1]?.when != null) {
            setA2When(new Date(data?.technicianCountermeasure[1]?.when));
        }
        //a3
        if (data?.technicianCountermeasure[2]?.what != "") {
            setA3What(data?.technicianCountermeasure[2]?.what);
        }
        if (data?.technicianCountermeasure[2]?.who != "") {
            setA3Who(data?.technicianCountermeasure[2]?.who);
        }
        if (data?.technicianCountermeasure[2]?.when != null) {
            setA3When(new Date(data?.technicianCountermeasure[2]?.when));
        }
        //a4
        if (data?.technicianCountermeasure[3]?.what != "") {
            setA4What(data?.technicianCountermeasure[3]?.what);
        }
        if (data?.technicianCountermeasure[3]?.who != "") {
            setA4Who(data?.technicianCountermeasure[3]?.who);
        }
        if (data?.technicianCountermeasure[3]?.when != null) {
            setA4When(new Date(data?.technicianCountermeasure[3]?.when));
        }
        //am
        if (data?.technicianCountermeasure[4]?.what != "") {
            setAmWhat(data?.technicianCountermeasure[4]?.what);
        }
        if (data?.technicianCountermeasure[4]?.who != "") {
            setAmWho(data?.technicianCountermeasure[4]?.who);
        }
        if (data?.technicianCountermeasure[4]?.when != null) {
            setAmWhen(new Date(data?.technicianCountermeasure[4]?.when));
        }
        //ft
        if (data?.technicianCountermeasure[5]?.what != "") {
            setFtWhat(data?.technicianCountermeasure[5]?.what);
        }
        if (data?.technicianCountermeasure[5]?.who != "") {
            setFtWho(data?.technicianCountermeasure[5]?.who);
        }
        if (data?.technicianCountermeasure[5]?.when != null) {
            setFtWhen(new Date(data?.technicianCountermeasure[5]?.when));
        }
        //sm
        if (data?.technicianCountermeasure[6]?.what != "") {
            setSmWhat(data?.technicianCountermeasure[6]?.what);
        }
        if (data?.technicianCountermeasure[6]?.who != "") {
            setSmWho(data?.technicianCountermeasure[6]?.who);
        }
        if (data?.technicianCountermeasure[6]?.when != null) {
            setSmWhen(data?.technicianCountermeasure[6]?.when);
        }
        //pm
        if (data?.technicianCountermeasure[7]?.what != "") {
            setPmWhat(data?.technicianCountermeasure[7]?.what);
        }
        if (data?.technicianCountermeasure[7]?.who != "") {
            setPmWho(data?.technicianCountermeasure[7]?.who);
        }
        if (data?.technicianCountermeasure[7]?.when != null) {
            setPmWhen(data?.technicianCountermeasure[7]?.when);
        }
        //dr
        if (data?.technicianCountermeasure[8]?.what != "") {
            setDrWhat(data?.technicianCountermeasure[8]?.what);
        }
        if (data?.technicianCountermeasure[8]?.who != "") {
            setDrWho(data?.technicianCountermeasure[8]?.who);
        }
        if (data?.technicianCountermeasure[8]?.when != null) {
            setDrWhen(data?.technicianCountermeasure[8]?.when);
        }
        //as
        if (data?.technicianCountermeasure[9]?.what != "") {
            setAsWhat(data?.technicianCountermeasure[9]?.what);
        }
        if (data?.technicianCountermeasure[9]?.who != "") {
            setAsWho(data?.technicianCountermeasure[9]?.who);
        }
        if (data?.technicianCountermeasure[9]?.when != null) {
            setAsWhen(data?.technicianCountermeasure[9]?.when);
        }
        //pl
        if (data?.technicianCountermeasure[10]?.what != "") {
            setPlWhat(data?.technicianCountermeasure[10]?.what);
        }
        if (data?.technicianCountermeasure[10]?.who != "") {
            setPlWho(data?.technicianCountermeasure[10]?.who);
        }
        if (data?.technicianCountermeasure[10]?.when != null) {
            setPlWhen(data?.technicianCountermeasure[10]?.when);
        }
    };
    //sayfa ilk açıldığında taslak olarak kaydedilmiş olan veri varsa getirilir
    useEffect(() => {
        if (isEdit && fromPage === "detail") {
            const data = formDetail;
            setIsOperatorDisable(true);
            setIsCancelDisable(true);
            const emergencyList = data?.userEmergencyWorkOrder ?? [];
            const userList = emergencyList.map((item) => ({ userId: item.userId }));
            setTechnicianIds(userList);
            if (data?.rootCausesFamilyDetail?.rootCausesFamilyId != 0) {
                const relationId = data?.rootCausesFamilyDetail?.rootCausesFamilyOptionId;
                setRootCauseFamilyRelationId(relationId);
                const familyName = data?.rootCausesFamilyDetail?.rootCausesFamilyName;
                const familyId = data?.rootCausesFamilyDetail?.rootCausesFamilyOptionId;
                if (familyName === "Lack Of Basic Conditions") {
                    setSelectedLackOfCondition(familyId);
                } else if (familyName === "Failure To Respect Op. Cond.") {
                    setSelectedFailureToRespect(familyId);
                } else if (familyName === "Lack Of Maintenance") {
                    setSelectedLackOfMaintenance(familyId);
                } else if (familyName === "Insufficient Skills") {
                    setSelectedInsufficientSkills(familyId);
                } else if (familyName === "Design Weaknesses") {
                    setSelectedDesignWeaknesses(familyId);
                } else if (familyName === "External Influences") {
                    setSelectedExternalInfluences(familyId);
                }
            }

            if (data?.analysisExecutedBy != "" && data?.analysisExecutedBy != null) {
                setExecutedTechnicianId(data.analysisExecutedBy);
                setExecutedTechnicianName(data?.analysisExecutedByName);
                setExecutedErrorText("");
                setHasExecutedError(false);
            }
            if (data?.verifiedBy != "" && data?.verifiedBy != null) {
                setVerifiedTechnicianId(data?.verifiedBy);
                setVerifiedTechnicianName(data?.verifierByName);
                setVerifiedErrorText("");
                setHasVerifiedError(false);
            }
            parseForm(data);
        }
    }, [formDetail])

    useEffect(() => {
        if (fromPage === "detail" && draft && !isEdit) {
            if (draft.rootCauseFamilyId != 0) {
                const relationId = draft?.rootCausesFamilyRelation.rootCauseFamilyRelationId;
                const rootCauseFamilyId = draft.rootCauseFamilyId;
                setRootCauseFamilyRelationId(relationId);
                const setters = {
                    1: setSelectedLackOfCondition,
                    2: setSelectedFailureToRespect,
                    3: setSelectedLackOfMaintenance,
                    4: setSelectedInsufficientSkills,
                    5: setSelectedDesignWeaknesses,
                    6: setSelectedExternalInfluences,
                    default: () => { },
                };

                (setters[rootCauseFamilyId] || setters.default)(relationId);
            }
            if (data?.analysisExecutedBy != "" && data?.analysisExecutedBy != null) {
                setExecutedTechnicianId(data.analysisExecutedBy);
                const executedTechnician = technicianList?.filter((x) => x.userCode == data.analysisExecutedBy);
                if (executedTechnician != null) {
                    setExecutedTechnicianName(executedTechnician[0]?.userName);
                    setExecutedErrorText("");
                    setHasExecutedError(false);
                }
            }
            if (data.verifiedBy != "" && data.verifiedBy != null) {
                setVerifiedTechnicianId(data.verifiedBy);
                const verifiedTechnicianName = technicianList?.filter((x) => x.userCode == data.verifiedBy);
                if (verifiedTechnicianName != null) {
                    setVerifiedTechnicianName(verifiedTechnicianName[0]?.userName);
                    setVerifiedErrorText("");
                    setHasVerifiedError(false);
                }
            }
            parseForm(draft);
        }
    }, [draft]);

    // Base64'ü Blob'a dönüştür
    const base64ToBlob = (contentBase64, mimeType) => {
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    };
    const extractZipFile = async (blob) => {
        const jszip = new JSZip();

        try {
            const zip = await jszip.loadAsync(blob); // Zip dosyasını yükle
            const files = zip.files; // Zip dosyasındaki tüm dosyalar

            // Zip dosyasında resim dosyasını bulun
            Object.keys(files).forEach(async (filename) => {
                if (filename.endsWith(".jpg") || filename.endsWith(".png")) {
                    const imageBlob = await zip.file(filename).async("blob"); // Resmi blob olarak al
                    
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setImages([{ data_url: reader.result, file: new File([imageBlob], "ksjdls") }]);
                    };
                    reader.readAsDataURL(imageBlob);
                }
            });
        } catch (error) {
            console.error("Error extracting zip file:", error);
        }
    };

    useEffect(() => {
        if (ewoForm.ewoFormDetailById.ewoForm && fromPage === "list") {
            const data = ewoForm.ewoFormDetailById.ewoForm;
            var x = base64ToBlob(ewoForm.ewoFormDetailById.zipFile.contentBase64, ewoForm.ewoFormDetailById.zipFile.fileName);
            extractZipFile(x);
            setIsOperatorDisable(true);
            setIsSaveDisable(true);
            setIsCancelDisable(true);
            setEquipmentTitleName(data.equipmentName);
            setTechnicianIds(data.userCode);
            setMainEquipmentCode(data.mainEquipmentName ?? null);
            setEquipmentName(data.equipmentName);
            setEwoCode(data.ewoCode);

            setTaskCreatedDate(data.recordOfIntervention.timeBreakdownOccured);
            setWaitMin(data.recordOfIntervention.wait);
            setDiagnosisMin(data.recordOfIntervention.diagnosis);
            setSpSearchMin(data.recordOfIntervention.sparePartSearch);
            setRepairingMin(data.recordOfIntervention.repairing);
            setStartUpMin(data.recordOfIntervention.startUp);
            setInterventionEndedDate(data.recordOfIntervention.interventionEnded);
            setBreakdownReasonGroupName(data.recordOfIntervention.breakdownGroupName);

            setWhat(data.operatorFiveWsOneHAnalysis.what);
            setWhere(data.operatorFiveWsOneHAnalysis.where);
            setWho(data.operatorFiveWsOneHAnalysis.who);
            setWhich(data.operatorFiveWsOneHAnalysis.which);
            setHow(data.operatorFiveWsOneHAnalysis.how);
            setSelectedRadioValue(data.operatorFiveWsOneHAnalysis.when);
            setDescriptionOfActivities(data.descriptionOfActivity);

            setCauseA(data.listOfPossibleCause.causeA);
            setCauseB(data.listOfPossibleCause.causeB);
            setCauseC(data.listOfPossibleCause.causeC);

            setPossibleCauseA(data.verificationOfPossibleCause.causeA);
            setPossibleCauseB(data.verificationOfPossibleCause.causeB);
            setPossibleCauseC(data.verificationOfPossibleCause.causeC);
            setPossibleCauseAStatus(data.verificationOfPossibleCause.causeAStatus);
            setPossibleCauseBStatus(data.verificationOfPossibleCause.causeBStatus);
            setPossibleCauseCStatus(data.verificationOfPossibleCause.causeCStatus);

            fillTechnicianFiveWsOneHAnalysisAreas(data.technicianFiveWsOneHAnalysis);
            fillTechnicianCountermeasure(data.technicianCountermeasure);

            setTechnicianNames(data.userEmergencyWorkOrder);
            setHasTechinicianError(false);
            setTechnicianErrorText("");
            setEwoCreatedDate(data.date);
            setHasEwoCreatedDateError(false);
            setEwoCreatedDateErrorText("");

            setHasWaitMinError(false);
            setWaitMinErrorText("");
            setHasDiagnosisMinError(false);
            setDiagnosisMinErrorText("");
            setHasSpSearchMinError(false);
            setSpSearchMinErrorText("");
            setHasRepairingMinError(false);
            setRepairingMinErrorText("");
            setHasStartUpMinError(false);
            setStartUpMinErrorText("");
            setHasBreakdownGroupError(false);
            setBreakdownGroupErrorText("");

            setHasWhatError(false);
            setWhatErrorText("");
            setHasWhereError(false);
            setWhereErrorText("");
            setHasWhoError(false);
            setWhoErrorText("");
            setHasWhichError(false);
            setWhichErrorText("");
            setHasHowError(false);
            setHowErrorText("");
            setHasDescriptionError(false);
            setDescriptionErrorText("");

            setHasCauseAError(false);
            setCauseAErrorText("");
            setHasPossibleCauseAError(false);
            setPossibleCauseAErrorText("");

            setHasHypothesis1_1Error(false);
            setHypothesis1_1ErrorText("");

            setExecutedTechnicianName(data.analysisExecutedByName);
            setHasExecutedError(false);
            setExecutedErrorText("");

            setVerifiedTechnicianName(data.verifierByName);
            setHasVerifiedError(false);
            setVerifiedErrorText("");

            setSignature(data.signature);
            setHasSignatureError(false);
            setSignatureErrorText("");

            setClosureDate(data.closureDate);
            setHasClosureDateError(false);
            setClosureDateErrorText("");

            setHasWhenError(false);

            setSelectedLackOfCondition(data.rootCausesFamilyDetail.rootCausesFamilyOptionId);
            setSelectedFailureToRespect(data.rootCausesFamilyDetail.rootCausesFamilyOptionId);
            setSelectedLackOfMaintenance(data.rootCausesFamilyDetail.rootCausesFamilyOptionId);
            setSelectedInsufficientSkills(data.rootCausesFamilyDetail.rootCausesFamilyOptionId);
            setSelectedDesignWeaknesses(data.rootCausesFamilyDetail.rootCausesFamilyOptionId);
            setSelectedExternalInfluences(data.rootCausesFamilyDetail.rootCausesFamilyOptionId);

            disableAllStates();
            ewoForm.ewoFormDetailById = {};
        }
        if (fromPage === "operator") {
            setHasTechinicianError(false);
            setTechnicianErrorText("");
            setHasEwoCreatedDateError(false);
            setEwoCreatedDateErrorText("");
            setHasWaitMinError(false);
            setWaitMinErrorText("");
            setHasDiagnosisMinError(false);
            setDiagnosisMinErrorText("");
            setHasSpSearchMinError(false);
            setSpSearchMinErrorText("");
            setHasRepairingMinError(false);
            setRepairingMinErrorText("");
            setHasStartUpMinError(false);
            setStartUpMinErrorText("");
            setHasBreakdownGroupError(false);
            setBreakdownGroupErrorText("");
            setHasDescriptionError(false);
            setDescriptionErrorText("");
            setHasCauseAError(false);
            setCauseAErrorText("");
            setHasPossibleCauseAError(false);
            setPossibleCauseAErrorText("");
            setHasHypothesis1_1Error(false);
            setHypothesis1_1ErrorText("");
            setHasExecutedError(false);
            setExecutedErrorText("");
            setHasVerifiedError(false);
            setVerifiedErrorText("");
            setHasSignatureError(false);
            setSignatureErrorText("");
            setHasClosureDateError(false);
            setClosureDateErrorText("");
            setHasWhenError(false);
            disableOperatorFields();
        }
    }, [ewoForm.ewoFormDetailById]);

    useEffect(() => {
        if (ewoForm.operatorFiveWsOneHAnalysis.resultObject !== undefined) {
            setOperatorFiveWsOneHAnalysis(ewoForm.operatorFiveWsOneHAnalysis.resultObject);
        }
    }, [ewoForm.operatorFiveWsOneHAnalysis]);

    useEffect(() => {
        //operatörün girdiği bilgiler çekildikten sonra teknisyen data girişi yaparken operatörün girdiği bilgiler otomatik set edilir.
        if (ewoForm.ewoFormOperatorFields?.resultObject) {
            setOperatorTaskId(ewoForm.ewoFormOperatorFields.resultObject.taskId);
            setWhat(ewoForm.ewoFormOperatorFields.resultObject.operatorFiveWsOneHAnalysis.what);
            setWhere(ewoForm.ewoFormOperatorFields.resultObject.operatorFiveWsOneHAnalysis.where);
            setWho(ewoForm.ewoFormOperatorFields.resultObject.operatorFiveWsOneHAnalysis.who);
            setWhich(ewoForm.ewoFormOperatorFields.resultObject.operatorFiveWsOneHAnalysis.which);
            setHow(ewoForm.ewoFormOperatorFields.resultObject.operatorFiveWsOneHAnalysis.how);
            setSelectedRadioValue(ewoForm.ewoFormOperatorFields.resultObject.operatorFiveWsOneHAnalysis.when);
            setOpeatorFieldsDefault();
        }
    }, [ewoForm.ewoFormOperatorFields]);

    const [selectedRadioValue, setSelectedRadioValue] = useState(0);

    //operator tarafi save butonu icin
    useEffect(() => {
        if (fromPage === "operator") {
            if (hasWhatError || hasWhenError || hasWhereError || hasWhoError || hasWhichError || hasHowError || selectedRadioValue === 0) {
                setIsOperatorDisable(true);
            } else {
                setIsOperatorDisable(false);
            }
        }
    }, [fromPage, hasWhatError, hasWhenError, hasWhereError, hasWhoError, hasWhichError, hasHowError, selectedRadioValue]);

    useEffect(() => {
        if (
            hasTechinicianError ||
            hasEwoCreatedDateError ||
            hasWaitMinError ||
            hasDiagnosisMinError ||
            hasSpSearchMinError ||
            hasRepairingMinError ||
            hasStartUpMinError ||
            hasBreakdownGroupError ||
            hasWhatError ||
            hasWhereError ||
            hasWhoError ||
            hasWhichError ||
            hasHowError ||
            hasDescriptionError ||
            hasCauseAError ||
            hasPossibleCauseAError ||
            hasHypothesis1_1Error ||
            hasExecutedError ||
            hasVerifiedError ||
            hasSignatureError ||
            hasClosureDateError ||
            (selectedDesignWeaknesses === 0 &&
                selectedExternalInfluences === 0 &&
                selectedFailureToRespect === 0 &&
                selectedInsufficientSkills === 0 &&
                selectedLackOfCondition === 0 &&
                selectedLackOfMaintenance === 0) ||
            fromPage === "list" ||
            images.length === 0
        ) {
            setIsSaveDisable(true);
        } else {
            setIsSaveDisable(false);
        }
    }, [
        hasTechinicianError,
        hasEwoCreatedDateError,
        hasWaitMinError,
        hasDiagnosisMinError,
        hasSpSearchMinError,
        hasRepairingMinError,
        hasStartUpMinError,
        hasBreakdownGroupError,
        hasWhatError,
        hasWhereError,
        hasWhoError,
        hasWhichError,
        hasHowError,
        hasDescriptionError,
        hasCauseAError,
        hasPossibleCauseAError,
        hasHypothesis1_1Error,
        hasExecutedError,
        hasVerifiedError,
        hasSignatureError,
        hasClosureDateError,
        selectedDesignWeaknesses,
        selectedExternalInfluences,
        selectedFailureToRespect,
        selectedInsufficientSkills,
        selectedLackOfCondition,
        selectedLackOfMaintenance,
        fromPage,
        images,
    ]);

    useEffect(() => {
        if (rootCauseFamilyAndOptions.rootCauseFamilyAndOptions.resultObject !== undefined) {
            setRootCauseFamilyAndOptionsState(rootCauseFamilyAndOptions.rootCauseFamilyAndOptions.resultObject);
            const organizedData = rootCauseFamilyAndOptions.rootCauseFamilyAndOptions.resultObject.reduce((acc, rootCause) => {
                const { rootCausesFamilyName, rootCausesFamilyOptions } = rootCause;

                if (!acc[rootCausesFamilyName]) {
                    acc[rootCausesFamilyName] = [];
                }

                acc[rootCausesFamilyName].push(rootCausesFamilyOptions);

                return acc;
            }, {});

            setLackOfBasicConditions(organizedData["Lack Of Basic Conditions"][0]);
            setFailureToRespect(organizedData["Failure To Respect Op. Cond."][0]);
            setLackOfMaintenance(organizedData["Lack Of Maintenance"][0]);
            setInsufficientSkills(organizedData["Insufficient Skills"][0]);
            setDesignWeaknesses(organizedData["Design Weaknesses"][0]);
            setExternalInfluences(organizedData["External Influences"][0]);
        }
    }, [rootCauseFamilyAndOptions]);

    useEffect(() => {
        if (plant?.plantList?.resultObject?.length) {
            setPlantName(plant.plantList.resultObject[0].name);
            setPlantId(plant.plantList.resultObject[0].id);
        }
    }, [plant]);

    const {
        user: { technicianList },
    } = useSelector((user) => user);

    useEffect(() => {
        if (technicianList) {
            setTechData(technicianList);
        }
    }, [technicianList]);

    useEffect(() => {
        if (res.BreakdownReasonGroupList) {
            if (res.BreakdownReasonGroupList?.errorCode === 0) {
                setBreakdownGroupData(res.BreakdownReasonGroupList?.resultObject);
            }
        }
    }, [res]);

    const loadHandler = () => {
        dispatch(getPlantList());
        dispatch(getRootCauseFamilyAndOptions());
        setMaintenanceOperatorsName(location.state?.data.creatorName);
        setMaintenanceOperatorsId(location.state?.data.creatorCode);
        setEquipmentName(location.state?.data.equipmentName);
        setEquipmentId(location.state?.data.equipmentId);
        setEwoCode("EWO_" + location.state?.data.id);
        setTaskCreatedDate(new Date(location.state?.data.createdDate));
        setMainEquipmentCode(location.state?.data.mainEquipmentCode ?? "");
        setMainEquipmentId(location.state?.data.mainEquipmentId !== 0 ? location.state?.data.mainEquipmentId : location.state?.data.equipmentId);
        setEquipmentTitleName(location.state?.data.equipmentName ?? "");
    };

    const dataURLtoBlob = (dataUrl) => {
        try {
            // Base64 öncesi ve sonrası kısımlarını ayrıştır
            const [header, base64Data] = dataUrl.split(",");

            // Mime türünü yakala
            const mimeMatch = header.match(/:(.*?);/);
            if (!mimeMatch) {
                throw new Error("Geçersiz mime türü.");
            }
            const mime = mimeMatch[1];

            // Base64'ü binary string'e çevir
            const binaryStr = atob(base64Data);

            // Binary string uzunluğu kadar bir Uint8Array oluştur
            const len = binaryStr.length;
            const u8arr = new Uint8Array(len);

            // Binary string'i Uint8Array'e çevir
            for (let i = 0; i < len; i++) {
                u8arr[i] = binaryStr.charCodeAt(i);
            }

            // Uint8Array'i Blob'a dönüştür ve geri döndür
            return new Blob([u8arr], { type: mime });
        } catch (error) {
            console.error("Blob oluşturulurken hata oluştu: ", error);
            return null; // Hata durumunda null döndür
        }
    };

    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        photoUploaded.current = true;
        var x = dataURLtoBlob(imageList[0].data_url);
        setBlobFile(x);
        setImages(imageList[0]);
    };

    //Operatörün doldurduğu alanları teknisyen giriş yaparken disable eder.
    const setOpeatorFieldsDefault = () => {
        setHasWhatError(false);
        setHasWhereError(false);
        setHasWhoError(false);
        setHasWhichError(false);
        setHasHowError(false);

        setWhatErrorText("");
        setWhereErrorText("");
        setWhoErrorText("");
        setWhichErrorText("");
        setHowErrorText("");
    };

    const handleDateChange = (date) => {
        if (date) {
            setEwoCreatedDate(new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString());
            localStorage.setItem("ewoCreatedDate", new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString());
            setHasEwoCreatedDateError(false);
            setEwoCreatedDateErrorText("");
        } else {
            setHasEwoCreatedDateError(true);
            setEwoCreatedDateErrorText(t("EmptyCheck"));
        }
    };

    const handleClosureDateChange = (date) => {
        if (date) {
            setClosureDate(date);
            setHasClosureDateError(false);
            setClosureDateErrorText("");
        } else {
            setHasClosureDateError(true);
            setClosureDateErrorText(t("EmptyCheck"));
        }
    };

    //maintenance opeators
    const handleTechnicianChange = (techName) => {
        let ids = techName.map((item) => item.id).join(", ");

        const techIds = techName.map((item) => item.id);
        const techIdsObjects = techIds.map((id) => ({ userId: id }));
        setTechnicianIds(techIdsObjects);
        setTechnicianNames(techName);
        if (ids.length > 0) {
            setHasTechinicianError(false);
            setTechnicianErrorText("");
        } else {
            setHasTechinicianError(true);
        }
    };

    const handleExecutedTechnicianChange = (techName) => {
        if (techName) {
            setExecutedTechnicianId(techName.userCode);
            setExecutedTechnicianName(techName.userName);
            setHasExecutedError(false);
            setExecutedErrorText("");
        } else {
            setExecutedErrorText(t("EmptyCheck"));
            setExecutedTechnicianId("");
            setExecutedTechnicianName("");
            setHasExecutedError(true);
        }
    };

    const handleVerifiedTechnicianChange = (techName) => {
        if (techName) {
            setVerifiedTechnicianId(techName.userCode);
            setVerifiedTechnicianName(techName.userName);
            setHasVerifiedError(false);
            setVerifiedErrorText("");
        } else {
            setVerifiedErrorText(t("EmptyCheck"));
            setVerifiedTechnicianId("");
            setVerifiedTechnicianName("");
            setHasVerifiedError(true);
        }
    };

    const handleSignatureChanged = (e) => {
        const value = e.target.value;

        if (value === true) {
            setSignature(value);
            setHasSignatureError(false);
            setSignatureErrorText("");
        } else {
            setSignature(value);
            setHasSignatureError(true);
            setSignatureErrorText(t("Must be OK"));
        }
    };

    const handleRemoveAll = () => {
        photoUploaded.current = false;
        setImages([]); // images'i boş bir array olarak set et
        deleteEwoFromFileByEwoId(location.state?.data.emergencyWorkOrderId);
    };

    const disableAllStates = () => {
        setDisableStates((prevState) => ({
            ...prevState,
            isMaintenanceOperatorDisabled: true,
            isPlantDisable: true,
            isLineDisable: true,
            isEquipmentDisable: true,
            isDateDisable: true,
            isEwoCodeDisable: true,
            isWaitDisable: true,
            isDiagnosisDisable: true,
            isSpSearchDisable: true,
            isRepairingDisable: true,
            isStartupDisable: true,
            isInterventionDateDisable: true,
            isBreakdownGroupDisable: true,
            isWhatDisable: true,
            isWhereDisable: true,
            isWhoDisable: true,
            isWhichDisable: true,
            isWhichRadioDisable: true,
            isHowDisable: true,
            isWhenDisable: true,
            isDescriptionOfActivitiesDisable: true,
            isCauseADisable: true,
            isCauseBDisable: true,
            isCauseCDisable: true,
            isPossibleCauseADisable: true,
            isPossibleCauseBDisable: true,
            isPossibleCauseCDisable: true,
            isPossibleCauseAStatusDisable: true,
            isPossibleCauseBStatusDisable: true,
            isPossibleCauseCStatusDisable: true,
            isHypothesis1_1Disable: true,
            isHypothesis1_2Disable: true,
            isHypothesis1_3Disable: true,
            isHypothesis1_4Disable: true,
            isHypothesis2_1Disable: true,
            isHypothesis2_2Disable: true,
            isHypothesis2_3Disable: true,
            isHypothesis2_4Disable: true,
            isHypothesis3_1Disable: true,
            isHypothesis3_2Disable: true,
            isHypothesis3_3Disable: true,
            isHypothesis3_4Disable: true,
            isHypothesis4_1Disable: true,
            isHypothesis4_2Disable: true,
            isHypothesis4_3Disable: true,
            isHypothesis4_4Disable: true,
            isHypothesis5_1Disable: true,
            isHypothesis5_2Disable: true,
            isHypothesis5_3Disable: true,
            isHypothesis5_4Disable: true,
            isA1WhatDisable: true,
            isA1WhoDisable: true,
            isA1WhenDisable: true,
            isA2WhatDisable: true,
            isA2WhoDisable: true,
            isA2WhenDisable: true,
            isA3WhatDisable: true,
            isA3WhoDisable: true,
            isA3WhenDisable: true,
            isA4WhatDisable: true,
            isA4WhoDisable: true,
            isA4WhenDisable: true,
            isAmWhatDisable: true,
            isAmWhoDisable: true,
            isAmWhenDisable: true,
            isFtWhatDisable: true,
            isFtWhoDisable: true,
            isFtWhenDisable: true,
            isSmWhatDisable: true,
            isSmWhoDisable: true,
            isSmWhenDisable: true,
            isPmWhatDisable: true,
            isPmWhoDisable: true,
            isPmWhenDisable: true,
            isDrWhatDisable: true,
            isDrWhoDisable: true,
            isDrWhenDisable: true,
            isAsWhatDisable: true,
            isAsWhoDisable: true,
            isAsWhenDisable: true,
            isPlWhatDisable: true,
            isPlWhoDisable: true,
            isPlWhenDisable: true,
            isExecutedDisable: true,
            isVerifiedDisable: true,
            isSignatureDisable: true,
            isClosureDateDisable: true,
        }));
    };

    //set breakdownReasonGroupCode

    const handleBreakdownGroupChange = (breakdownId) => {
        if (breakdownId != null) {
            const filteredReasonGroup = breakdownGroupData.filter((item) => item.name?.includes(breakdownId) || item.breakdownReasonGroupLocalizationName?.includes(breakdownId));
            setBreakdownGroupId(filteredReasonGroup[0].id);
            setBreakdownReasonGroupName(filteredReasonGroup[0].breakdownReasonGroupLocalizationName);
            setHasBreakdownGroupError(false);
            setBreakdownGroupErrorText("");
            return filteredReasonGroup[0].id;
        } else {
            setBreakdownGroupId(0);
            setBreakdownGroupErrorText(t("EmptyCheck"));
            setHasBreakdownGroupError(true);
            setBreakdownReasonGroupName("");
        }
    };

    const handleLackOfConditionChaged = (e) => {
        //we need to disable other options
        if (e.target.value !== 0) {
            setRootCauseFamilyId(1);
            setSelectedLackOfCondition(e.target.value);
            setRootCauseFamilyRelationId(e.target.value);
        } else {
            setRootCauseFamilyId(0);
            setSelectedLackOfCondition(0);
            setRootCauseFamilyRelationId(0);
        }
    };

    const handleFailuretoRespectChaged = (e) => {
        if (e.target.value !== 0) {
            setRootCauseFamilyId(2);
            setSelectedFailureToRespect(e.target.value);
            setRootCauseFamilyRelationId(e.target.value);
        } else {
            setRootCauseFamilyId(0);
            setSelectedFailureToRespect(0);
            setRootCauseFamilyRelationId(0);
        }
    };

    const handleLackOfMaintenanceChaged = (e) => {
        if (e.target.value !== 0) {
            setRootCauseFamilyId(3);
            setSelectedLackOfMaintenance(e.target.value);
            setRootCauseFamilyRelationId(e.target.value);
        } else {
            setRootCauseFamilyId(0);
            setSelectedLackOfMaintenance(0);
            setRootCauseFamilyRelationId(0);
        }
    };

    const handleInsufficientSkillsChaged = (e) => {
        if (e.target.value !== 0) {
            setRootCauseFamilyId(4);
            setSelectedInsufficientSkills(e.target.value);
            setRootCauseFamilyRelationId(e.target.value);
        } else {
            setRootCauseFamilyId(0);
            setSelectedInsufficientSkills(0);
            setRootCauseFamilyRelationId(0);
        }
    };

    const handleDesignWeaknessesChaged = (e) => {
        if (e.target.value !== 0) {
            setRootCauseFamilyId(5);
            setSelectedDesignWeaknesses(e.target.value);
            setRootCauseFamilyRelationId(e.target.value);
        } else {
            setRootCauseFamilyId(0);
            setSelectedDesignWeaknesses(0);
            setRootCauseFamilyRelationId(0);
        }
    };

    const handleExternalInfluencesChaged = (e) => {
        if (e.target.value !== 0) {
            setRootCauseFamilyId(6);
            setSelectedExternalInfluences(e.target.value);
            setRootCauseFamilyRelationId(e.target.value);
        } else {
            setRootCauseFamilyId(0);
            setSelectedExternalInfluences(0);
            setRootCauseFamilyRelationId(0);
        }
    };

    const handleRadioChange = (e) => {
        setSelectedRadioValue(e.target.value);
    };

    const handleWaitMinChange = (e) => {
        if (e.target.value >= 0) {
            setWaitMin(e.target.value);
            setHasWaitMinError(false);
            setWaitMinErrorText("");
        } else {
            setHasWaitMinError(true);
            setWaitMinErrorText(t("EmptyCheck"));
            setWaitMin("");
        }
    };

    const handleDiagnosisMinChange = (e) => {
        if (e.target.value >= 0) {
            setDiagnosisMin(e.target.value);
            setHasDiagnosisMinError(false);
            setDiagnosisMinErrorText("");
        } else {
            setHasDiagnosisMinError(true);
            setDiagnosisMinErrorText(t("EmptyCheck"));
            setDiagnosisMin("");
        }
    };

    const handleSpSearchMinChange = (e) => {
        if (e.target.value >= 0) {
            setSpSearchMin(e.target.value);
            setHasSpSearchMinError(false);
            setSpSearchMinErrorText("");
        } else {
            setHasSpSearchMinError(true);
            setSpSearchMinErrorText(t("EmptyCheck"));
            setSpSearchMin();
        }
    };

    const handleRepairingMinChange = (e) => {
        if (e.target.value >= 0) {
            setRepairingMin(e.target.value);
            setHasRepairingMinError(false);
            setRepairingMinErrorText("");
        } else {
            setHasRepairingMinError(true);
            setRepairingMinErrorText(t("EmptyCheck"));
            setRepairingMin("");
        }
    };

    const handleStartUpMinChange = (e) => {
        if (e.target.value >= 0) {
            setStartUpMin(e.target.value);
            setHasStartUpMinError(false);
            setStartUpMinErrorText("");
        } else {
            setHasStartUpMinError(true);
            setStartUpMinErrorText(t("EmptyCheck"));
            setStartUpMin("");
        }
    };

    const handleWhatChange = (e) => {
        if (e.target.value) {
            setWhat(e.target.value);
            setHasWhatError(false);
            setWhatErrorText("");
        } else {
            setHasWhatError(true);
            setWhatErrorText(t("EmptyCheck"));
            setWhat("");
        }
    };

    const handleWhereChange = (e) => {
        if (e.target.value) {
            setWhere(e.target.value);
            setHasWhereError(false);
            setWhereErrorText("");
        } else {
            setHasWhereError(true);
            setWhereErrorText(t("EmptyCheck"));
            setWhere("");
        }
    };

    const handleWhoChange = (e) => {
        if (e.target.value) {
            setWho(e.target.value);
            setHasWhoError(false);
            setWhoErrorText("");
        } else {
            setHasWhoError(true);
            setWhoErrorText(t("EmptyCheck"));
            setWho("");
        }
    };

    const handleWhichChange = (e) => {
        if (e.target.value) {
            setWhich(e.target.value);
            setHasWhichError(false);
            setWhichErrorText("");
        } else {
            setHasWhichError(true);
            setWhichErrorText(t("EmptyCheck"));
            setWhich("");
        }
    };

    const handleWhichRadioChange = (e) => {
        if (e.target.value === "1") {
            setDisableStates((prevState) => ({
                ...prevState,
                isWhichDisable: false,
            }));
            setHasWhichError(true);
            setWhichErrorText(t("EmptyCheck"));
        } else {
            setWhich("");
            setHasWhichError(false);
            setWhichErrorText("");
            setDisableStates((prevState) => ({
                ...prevState,
                isWhichDisable: true,
            }));
        }
    };

    const handleHowChange = (e) => {
        if (e.target.value) {
            setHow(e.target.value);
            setHasHowError(false);
            setHowErrorText("");
        } else {
            setHasHowError(true);
            setHowErrorText(t("EmptyCheck"));
            setHow("");
        }
    };

    const handleDescriptionOfActivitiesChange = (e) => {
        if (e.target.value) {
            setDescriptionOfActivities(e.target.value);
            setHasDescriptionError(false);
            setDescriptionErrorText("");
        } else {
            setHasDescriptionError(true);
            setDescriptionErrorText(t("EmptyCheck"));
            setDescriptionOfActivities("");
        }
    };

    const handleCauseAChange = (e) => {
        if (e.target.value) {
            setCauseA(e.target.value);
            setHasCauseAError(false);
            setCauseAErrorText("");
        } else {
            setHasCauseAError(true);
            setCauseAErrorText(t("EmptyCheck"));
            setCauseA("");
        }
    };

    const handlePossibleCauseAChange = (e) => {
        if (e.target.value) {
            setPossibleCauseA(e.target.value);
            setHasPossibleCauseAError(false);
            setPossibleCauseAErrorText("");
        } else {
            setHasPossibleCauseAError(true);
            setPossibleCauseAErrorText(t("EmptyCheck"));
            setPossibleCauseA("");
        }
    };

    const handleHypothesis1_1Change = (e) => {
        if (e.target.value) {
            setHypothesis1_1(e.target.value);
            setHasHypothesis1_1Error(false);
            setHypothesis1_1ErrorText("");
        } else {
            setHasHypothesis1_1Error(true);
            setHypothesis1_1ErrorText(t("EmptyCheck"));
            setHypothesis1_1("");
        }
    };

    const fillTechnicianFiveWsOneHAnalysisAreas = (data) => {
        data.forEach((element) => {
            if (element === data[0]) {
                setHypothesis1_1(element.hypothesis1);
                setHypothesis1_2(element.hypothesis2);
                setHypothesis1_3(element.hypothesis3);
                setHypothesis1_4(element.hypothesis4);
            } else if (element === data[1]) {
                setHypothesis2_1(element.hypothesis1);
                setHypothesis2_2(element.hypothesis2);
                setHypothesis2_3(element.hypothesis3);
                setHypothesis2_4(element.hypothesis4);
            } else if (element === data[2]) {
                setHypothesis3_1(element.hypothesis1);
                setHypothesis3_2(element.hypothesis2);
                setHypothesis3_3(element.hypothesis3);
                setHypothesis3_4(element.hypothesis4);
            } else if (element === data[3]) {
                setHypothesis4_1(element.hypothesis1);
                setHypothesis4_2(element.hypothesis2);
                setHypothesis4_3(element.hypothesis3);
                setHypothesis4_4(element.hypothesis4);
            } else {
                setHypothesis5_1(element.hypothesis1);
                setHypothesis5_2(element.hypothesis2);
                setHypothesis5_3(element.hypothesis3);
                setHypothesis5_4(element.hypothesis4);
            }
        });
    };

    const fillTechnicianCountermeasure = (data) => {
        data.forEach((element) => {
            if (element === data[0]) {
                setA1What(element.what);
                setA1Who(element.who);
                setA1When(element.when);
            } else if (element === data[1]) {
                setA2What(element.what);
                setA2Who(element.who);
                setA2When(element.when);
            } else if (element === data[2]) {
                setA3What(element.what);
                setA3Who(element.who);
                setA3When(element.when);
            } else if (element === data[3]) {
                setA4What(element.what);
                setA4Who(element.who);
                setA4When(element.when);
            } else if (element === data[4]) {
                setAmWhat(element.what);
                setAmWho(element.who);
                setAmWhen(element.when);
            } else if (element === data[5]) {
                setFtWhat(element.what);
                setFtWho(element.who);
                setFtWhen(element.when);
            } else if (element === data[6]) {
                setSmWhat(element.what);
                setSmWho(element.who);
                setSmWhen(element.when);
            } else if (element === data[7]) {
                setPmWhat(element.what);
                setPmWho(element.who);
                setPmWhen(element.when);
            } else if (element === data[8]) {
                setDrWhat(element.what);
                setDrWho(element.who);
                setDrWhen(element.when);
            } else if (element === data[9]) {
                setAsWhat(element.what);
                setAsWho(element.who);
                setAsWhen(element.when);
            } else {
                setPlWhat(element.what);
                setPlWho(element.who);
                setPlWhen(element.when);
            }
        });
    };

    const disableOperatorFields = () => {
        setDisableStates((prevState) => ({
            ...prevState,
            isMaintenanceOperatorDisabled: true,
            isPlantDisable: true,
            isLineDisable: true,
            isEquipmentDisable: true,
            isDateDisable: true,
            isEwoCodeDisable: true,
            isWaitDisable: true,
            isDiagnosisDisable: true,
            isSpSearchDisable: true,
            isRepairingDisable: true,
            isStartupDisable: true,
            isInterventionDateDisable: true,
            isBreakdownGroupDisable: true,
            isDescriptionOfActivitiesDisable: true,
            isCauseADisable: true,
            isCauseBDisable: true,
            isCauseCDisable: true,
            isPossibleCauseADisable: true,
            isPossibleCauseBDisable: true,
            isPossibleCauseCDisable: true,
            isPossibleCauseAStatusDisable: true,
            isPossibleCauseBStatusDisable: true,
            isPossibleCauseCStatusDisable: true,
            isHypothesis1_1Disable: true,
            isHypothesis1_2Disable: true,
            isHypothesis1_3Disable: true,
            isHypothesis1_4Disable: true,
            isHypothesis2_1Disable: true,
            isHypothesis2_2Disable: true,
            isHypothesis2_3Disable: true,
            isHypothesis2_4Disable: true,
            isHypothesis3_1Disable: true,
            isHypothesis3_2Disable: true,
            isHypothesis3_3Disable: true,
            isHypothesis3_4Disable: true,
            isHypothesis4_1Disable: true,
            isHypothesis4_2Disable: true,
            isHypothesis4_3Disable: true,
            isHypothesis4_4Disable: true,
            isHypothesis5_1Disable: true,
            isHypothesis5_2Disable: true,
            isHypothesis5_3Disable: true,
            isHypothesis5_4Disable: true,
            isA1WhatDisable: true,
            isA1WhoDisable: true,
            isA1WhenDisable: true,
            isA2WhatDisable: true,
            isA2WhoDisable: true,
            isA2WhenDisable: true,
            isA3WhatDisable: true,
            isA3WhoDisable: true,
            isA3WhenDisable: true,
            isA4WhatDisable: true,
            isA4WhoDisable: true,
            isA4WhenDisable: true,
            isAmWhatDisable: true,
            isAmWhoDisable: true,
            isAmWhenDisable: true,
            isFtWhatDisable: true,
            isFtWhoDisable: true,
            isFtWhenDisable: true,
            isSmWhatDisable: true,
            isSmWhoDisable: true,
            isSmWhenDisable: true,
            isPmWhatDisable: true,
            isPmWhoDisable: true,
            isPmWhenDisable: true,
            isDrWhatDisable: true,
            isDrWhoDisable: true,
            isDrWhenDisable: true,
            isAsWhatDisable: true,
            isAsWhoDisable: true,
            isAsWhenDisable: true,
            isPlWhatDisable: true,
            isPlWhoDisable: true,
            isPlWhenDisable: true,
            isExecutedDisable: true,
            isVerifiedDisable: true,
            isSignatureDisable: true,
            isClosureDateDisable: true,
        }));
    };

    //teknisyen save
    const HandleEwoSave = () => {
        const data = {
            taskId: location.state?.data.id,
            date: ewoCreatedDate,
            analysisExecutedBy: executedTechnicianId,
            verifiedBy: verifiedTechnicianId,
            signature: signature,
            closureDate: closureDate,
            descriptionOfActivity: descriptionOfActivities,

            recordOfIntervention: {
                emergencyWorkOrderId: ewoId,
                status: 1,
                timeBreakdownOccured: taskCreatedDate,
                wait: waitMin,
                diagnosis: diagnosisMin,
                sparePartSearch: spSearchMin,
                repairing: repairingMin,
                startUp: startUpMin,
                interventionEnded: interventionEndedDate,
                breakdownGroupId: breakdownGroupId,
            },

            listOfPossibleCause: {
                emergencyWorkOrderId: ewoId,
                status: 1,
                causeA: causeA,
                causeB: causeB,
                causeC: causeC,
            },

            verificationOfPossibleCause: {
                emergencyWorkOrderId: ewoId,
                status: 1,
                causeA: possibleCauseA,
                causeB: possibleCauseB,
                causeC: possibleCauseC,
                causeAStatus: possibleCauseAStatus,
                causeBStatus: possibleCauseBStatus,
                causeCStatus: possibleCauseCStatus,
            },

            technicianFiveWsOneHAnalysis: [
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    hypothesis1: hypothesis1_1,
                    hypothesis2: hypothesis1_2,
                    hypothesis3: hypothesis1_3,
                    hypothesis4: hypothesis1_4,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    hypothesis1: hypothesis2_1,
                    hypothesis2: hypothesis2_2,
                    hypothesis3: hypothesis2_3,
                    hypothesis4: hypothesis2_4,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    hypothesis1: hypothesis3_1,
                    hypothesis2: hypothesis3_2,
                    hypothesis3: hypothesis3_3,
                    hypothesis4: hypothesis3_4,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    hypothesis1: hypothesis4_1,
                    hypothesis2: hypothesis4_2,
                    hypothesis3: hypothesis4_3,
                    hypothesis4: hypothesis4_4,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    hypothesis1: hypothesis5_1,
                    hypothesis2: hypothesis5_2,
                    hypothesis3: hypothesis5_3,
                    hypothesis4: hypothesis5_4,
                },
            ],

            technicianCountermeasure: [
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: a1What,
                    who: a1Who,
                    when: a1When,
                    countermeasureId: 1,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: a2What,
                    who: a2Who,
                    when: a2When,
                    countermeasureId: 2,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: a3What,
                    who: a3Who,
                    when: a3When,
                    countermeasureId: 3,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: a4What,
                    who: a4Who,
                    when: a4When,
                    countermeasureId: 4,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: amWhat,
                    who: amWho,
                    when: amWhen,
                    countermeasureId: 5,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: ftWhat,
                    who: ftWho,
                    when: ftWhen,
                    countermeasureId: 6,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: smWhat,
                    who: smWho,
                    when: smWhen,
                    countermeasureId: 7,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: pmWhat,
                    who: pmWho,
                    when: pmWhen,
                    countermeasureId: 8,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: drWhat,
                    who: drWho,
                    when: drWhen,
                    countermeasureId: 9,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: asWhat,
                    who: asWho,
                    when: asWhen,
                    countermeasureId: 10,
                },
                {
                    emergencyWorkOrderId: ewoId,
                    status: 1,
                    what: plWhat,
                    who: plWho,
                    when: plWhen,
                    countermeasureId: 11,
                },
            ],

            rootCausesFamilyRelation: {
                emergencyWorkOrderId: ewoId,
                status: 1,
                rootCauseFamilyRelationId: rootCauseFamilyRelationId,
            },
            userEmergencyWorkOrder: technicianIds,
        };
        //images[0] should be blob
        if (photoUploaded.current) {
            const formData = new FormData();
            if (!blobFile) setBlobFile(blobResponse);
            formData.append("files", blobFile, "image.png");
            const payload = {
                id: location.state?.data?.emergencyWorkOrderId,
                file: formData,
            };
            dispatch(postEwoFormFileWithEwoId(payload));
        }
        console.log(data);
        dispatch(postEwoFormCreateWithFile(data));
        dispatch(getOperatorFieldsByTaskId(location.state?.data.id));
        skipDraftSave.current = true;
        deleteToDraftsByTaskId(taskId);
        HandleEwoSaveAsOperator();
        history.push("breakdowndetail?id=" + data.taskId);
    };

    //operator save
    const HandleEwoSaveAsOperator = () => {
        const data = {
            status: 1,
            plantId: plantId,
            line: mainEquipmentId,
            equipmentId: equipmentId,
            ewoCode: ewocode,
            operatorFiveWsOneHAnalysis: {
                what: what,
                where: where,
                when: selectedRadioValue,
                who: who,
                which: which,
                how: how,
            },
            taskId: location.state?.data.id,
        };
        dispatch(postEwoFormCreateWithOperatorFields(data));
        history.push("breakdowndetail?id=" + data.taskId);
    };

    //go breakdown detail page
    const BackToBreakdownListPage = () => {
        props.history.goBack();
    };

    const calculateInterventionEndedDate = () => {
        // taskCreatedDate'in bir Date nesnesi olup olmadığını kontrol et
        let taskCreated = new Date(taskCreatedDate);

        // taskCreatedDate geçerli bir tarih mi? Kontrol et
        if (isNaN(taskCreated.getTime())) {
            console.error("taskCreatedDate is not a valid date");
            return; // Geçerli bir tarih değilse işlemi durdur
        }

        // Her bir state'in sayısal olduğundan emin ol (NaN durumlarını da kontrol edebilirsin)
        let totalMinutes = Number(waitMin || 0) + Number(diagnosisMin || 0) + Number(spSearchMin || 0) + Number(repairingMin || 0) + Number(startUpMin || 0);

        // taskCreatedDate'e toplam dakikayı ekle
        let newInterventionEndedDate = new Date(taskCreated.getTime() + totalMinutes * 60000); // 60000 ms = 1 dakika

        // Date'in geçerli olup olmadığını kontrol et
        if (isNaN(newInterventionEndedDate.getTime())) {
            console.error("newInterventionEndedDate is not a valid date");
            return;
        }

        // interventionEndedDate state'ini güncelle
        setInterventionEndedDate(newInterventionEndedDate.toISOString());
    };

    useEffect(() => {
        // waitMin, diagnosisMin, spSearchMin, repairingMin, startUpMin veya taskCreatedDate değiştiğinde otomatik hesaplama yap
        calculateInterventionEndedDate();
    }, [waitMin, diagnosisMin, spSearchMin, repairingMin, startUpMin, taskCreatedDate]);

    const data = {
        isPhotoUploaded: photoUploaded.current,
        ...(rootCauseFamilyId !== 0 && { rootCauseFamilyId }),
        taskId: location.state?.data.id,
        date: ewoCreatedDate,
        analysisExecutedBy: executedTechnicianId,
        verifiedBy: verifiedTechnicianId,
        signature: hasSignatureError ? false : signature,
        closureDate: closureDate,
        descriptionOfActivity: descriptionOfActivities,

        recordOfIntervention: {
            status: 1,
            timeBreakdownOccured: taskCreatedDate,
            wait: waitMin,
            diagnosis: diagnosisMin,
            sparePartSearch: spSearchMin,
            repairing: repairingMin,
            startUp: startUpMin,
            interventionEnded: interventionEndedDate,
            breakdownGroupId: hasBreakdownGroupError ? -1 : breakdownGroupId,
        },

        listOfPossibleCause: {
            status: 1,
            causeA: causeA,
            causeB: causeB,
            causeC: causeC,
        },

        verificationOfPossibleCause: {
            status: 1,
            causeA: possibleCauseA,
            causeB: possibleCauseB,
            causeC: possibleCauseC,
            causeAStatus: possibleCauseAStatus,
            causeBStatus: possibleCauseBStatus,
            causeCStatus: possibleCauseCStatus,
        },

        technicianFiveWsOneHAnalysis: [
            {
                status: 1,
                hypothesis1: hypothesis1_1,
                hypothesis2: hypothesis1_2,
                hypothesis3: hypothesis1_3,
                hypothesis4: hypothesis1_4,
            },
            {
                status: 1,
                hypothesis1: hypothesis2_1,
                hypothesis2: hypothesis2_2,
                hypothesis3: hypothesis2_3,
                hypothesis4: hypothesis2_4,
            },
            {
                status: 1,
                hypothesis1: hypothesis3_1,
                hypothesis2: hypothesis3_2,
                hypothesis3: hypothesis3_3,
                hypothesis4: hypothesis3_4,
            },
            {
                status: 1,
                hypothesis1: hypothesis4_1,
                hypothesis2: hypothesis4_2,
                hypothesis3: hypothesis4_3,
                hypothesis4: hypothesis4_4,
            },
            {
                status: 1,
                hypothesis1: hypothesis5_1,
                hypothesis2: hypothesis5_2,
                hypothesis3: hypothesis5_3,
                hypothesis4: hypothesis5_4,
            },
        ],

        technicianCountermeasure: [
            {
                status: 1,
                what: a1What,
                who: a1Who,
                when: a1When,
                countermeasureId: 1,
            },
            {
                status: 1,
                what: a2What,
                who: a2Who,
                when: a2When,
                countermeasureId: 2,
            },
            {
                status: 1,
                what: a3What,
                who: a3Who,
                when: a3When,
                countermeasureId: 3,
            },
            {
                status: 1,
                what: a4What,
                who: a4Who,
                when: a4When,
                countermeasureId: 4,
            },
            {
                status: 1,
                what: amWhat,
                who: amWho,
                when: amWhen,
                countermeasureId: 5,
            },
            {
                status: 1,
                what: ftWhat,
                who: ftWho,
                when: ftWhen,
                countermeasureId: 6,
            },
            {
                status: 1,
                what: smWhat,
                who: smWho,
                when: smWhen,
                countermeasureId: 7,
            },
            {
                status: 1,
                what: pmWhat,
                who: pmWho,
                when: pmWhen,
                countermeasureId: 8,
            },
            {
                status: 1,
                what: drWhat,
                who: drWho,
                when: drWhen,
                countermeasureId: 9,
            },
            {
                status: 1,
                what: asWhat,
                who: asWho,
                when: asWhen,
                countermeasureId: 10,
            },
            {
                status: 1,
                what: plWhat,
                who: plWho,
                when: plWhen,
                countermeasureId: 11,
            },
        ],

        rootCausesFamilyRelation: {
            status: 1,
            rootCauseFamilyRelationId: rootCauseFamilyRelationId,
        },
        userEmergencyWorkOrder: technicianIds,
    };
    const dataRef = useRef(data);
    useEffect(() => {
        dataRef.current = data;
    }, [data]);

    const savePhotoToDraft = async () => {
        if (!(blobFile instanceof Blob)) return;

        const formData = new FormData();
        formData.append("files", blobFile, "image.png");
        const payload = {
            id: location.state?.data.emergencyWorkOrderId,
            file: formData,
        };
        await dispatch(postEwoFormFileWithEwoId(payload));
    };

    useEffect(() => {
        const unblock = history.block((tx) => {
            if (!skipDraftSave.current && shouldBlockNavigation) {
                setShouldBlockNavigation(false);
                (async () => {
                    await postAddEwoFormToDrafts(dataRef.current);
                    if (blobFile) await savePhotoToDraft();
                    unblock();
                    tx.retry();
                })();
            }
        });
        return () => unblock();
    }, [history, shouldBlockNavigation, blobFile]);

    //kullanıcı tarayıcıyı kapatırsa veriler taslak olarak kaydedilir
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = "";
            if (!skipDraftSave.current && dataRef.current) {
                postAddEwoFormToDrafts(dataRef.current);
                if (blobFile) savePhotoToDraft();
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [blobFile]);

    //go breakdown detail page
    const BackToBreakdownDetailPage = () => {
        props.history.goBack();
    };

    return (
        <Container className="printable-form" sx={{ minWidth: "1370px", padding: 1 }} ref={(el) => (componentRef = el)}>
            <Grid id="bd_grid" container alignItems="center">
                <Grid id="bd_grid_1" item xs={1}>
                    <IconButton id="bd_iconBtn" onClick={BackToBreakdownDetailPage} size="large">
                        <ArrowBackIos id="bd_arrowBack" fontSize="inherit" align="left" />
                    </IconButton>
                </Grid>
            </Grid>
            <div>
                <Paper
                    elevation={3}
                    sx={{
                        backgroundColor: "#FCF3CF", // soft grey
                    }}
                >
                    <Grid sx={{ p: 1 }}>
                        <Header equipmentTitle={equipmentTitleName} />
                    </Grid>

                    <Grid container sx={{ p: 1, pt: 0 }}>
                        <Grid container xs={12} sm={12} md={12}>
                            <EquipmentInfo
                                plantName={plantName}
                                mainEquipmentCode={mainEquipmentCode}
                                equipmentName={equipmentName}
                                disableStates={disableStates}
                                technicianNames={technicianNames}
                                techData={techData}
                                hasTechinicianError={hasTechinicianError}
                                technicianErrorText={technicianErrorText}
                                handleTechnicianChange={handleTechnicianChange}
                                hasEwoCreatedDateError={hasEwoCreatedDateError}
                                ewoCreatedDateErrorText={ewoCreatedDateErrorText}
                                ewoCreatedDate={ewoCreatedDate}
                                handleDateChange={handleDateChange}
                                ewocode={ewocode}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className="page-1">
                        {/* RECORD OF INTERVENTION */}
                        <RecordOfIntervention
                            taskCreatedDate={taskCreatedDate}
                            onTaskCreatedDateChange={setTaskCreatedDate}
                            disableStates={disableStates}
                            waitMin={waitMin}
                            handleWaitMinChange={handleWaitMinChange}
                            hasWaitMinError={hasWaitMinError}
                            waitMinErrorText={waitMinErrorText}
                            diagnosisMin={diagnosisMin}
                            handleDiagnosisMinChange={handleDiagnosisMinChange}
                            hasDiagnosisMinError={hasDiagnosisMinError}
                            diagnosisMinErrorText={diagnosisMinErrorText}
                            spSearchMin={spSearchMin}
                            handleSpSearchMinChange={handleSpSearchMinChange}
                            hasSpSearchMinError={hasSpSearchMinError}
                            spSearchMinErrorText={spSearchMinErrorText}
                            repairingMin={repairingMin}
                            handleRepairingMinChange={handleRepairingMinChange}
                            hasRepairingMinError={hasRepairingMinError}
                            repairingMinErrorText={repairingMinErrorText}
                            startUpMin={startUpMin}
                            handleStartUpMinChange={handleStartUpMinChange}
                            hasStartUpMinError={hasStartUpMinError}
                            startUpMinErrorText={startUpMinErrorText}
                            interventionEndedDate={interventionEndedDate}
                            breakdownGroupData={breakdownGroupData}
                            handleBreakdownGroupChange={handleBreakdownGroupChange}
                            breakdownReasonGroupName={breakdownReasonGroupName}
                            hasBreakdownGroupError={hasBreakdownGroupError}
                            breakdownGroupErrorText={breakdownGroupErrorText}
                            images={images}
                            onChange={onChange}
                            fromPage={fromPage}
                            handleRemoveAll={handleRemoveAll}
                        />

                        {/* 5W + 1H ANALYSIS */}
                        <FiveWOneHAnalysis
                            what={what}
                            disableStates={disableStates}
                            handleWhatChange={handleWhatChange}
                            hasWhatError={hasWhatError}
                            whatErrorText={whatErrorText}
                            selectedRadioValue={selectedRadioValue}
                            operatorFiveWsOneHAnalysis={operatorFiveWsOneHAnalysis}
                            handleRadioChange={handleRadioChange}
                            where={where}
                            handleWhereChange={handleWhereChange}
                            hasWhereError={hasWhereError}
                            whereErrorText={whereErrorText}
                            who={who}
                            handleWhoChange={handleWhoChange}
                            hasWhoError={hasWhoError}
                            whoErrorText={whoErrorText}
                            handleWhichRadioChange={handleWhichRadioChange}
                            which={which}
                            handleWhichChange={handleWhichChange}
                            hasWhichError={hasWhichError}
                            whichErrorText={whichErrorText}
                            how={how}
                            handleHowChange={handleHowChange}
                            hasHowError={hasHowError}
                            howErrorText={howErrorText}
                            descriptionOfActivities={descriptionOfActivities}
                            handleDescriptionOfActivitiesChange={handleDescriptionOfActivitiesChange}
                            hasDescriptionError={hasDescriptionError}
                            descriptionErrorText={descriptionErrorText}
                        />

                        {/*LIST OF POSSIBLE CAUSES*/}
                        <ListOfPossibleCauses
                            disableStates={disableStates}
                            causeA={causeA}
                            handleCauseAChange={handleCauseAChange}
                            hasCauseAError={hasCauseAError}
                            causeAErrorText={causeAErrorText}
                            causeB={causeB}
                            setCauseB={setCauseB}
                            causeC={causeC}
                            setCauseC={setCauseC}
                        />

                        {/* VERIFICATION OF POSSIBLE CAUSES(OK = true reason) */}
                        <VerificationOfPossibleCauses
                            disableStates={disableStates}
                            possibleCauseA={possibleCauseA}
                            handlePossibleCauseAChange={handlePossibleCauseAChange}
                            hasPossibleCauseAError={hasPossibleCauseAError}
                            possibleCauseAErrorText={possibleCauseAErrorText}
                            possibleCauseAStatus={possibleCauseAStatus}
                            setPossibleCauseAStatus={setPossibleCauseAStatus}
                            possibleCauseB={possibleCauseB}
                            setPossibleCauseB={setPossibleCauseB}
                            possibleCauseBStatus={possibleCauseBStatus}
                            setPossibleCauseBStatus={setPossibleCauseBStatus}
                            possibleCauseC={possibleCauseC}
                            setPossibleCauseC={setPossibleCauseC}
                            possibleCauseCStatus={possibleCauseCStatus}
                            setPossibleCauseCStatus={setPossibleCauseCStatus}
                        />
                    </Grid>

                    <Grid className="page-2" container alignItems="center" justifyContent="center" sx={{ p: 1 }}>
                        <Box
                            sx={{
                                p: 2,
                                width: "100%",
                                backgroundColor: theme.palette.grey[100],
                                borderRadius: "12px",
                                boxShadow: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                            }}
                        >
                            {/* Logo */}
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    maxHeight: 60,
                                }}
                            >
                                <img
                                    src={require("../../assets/beko_logo.png")}
                                    alt="Beko Logo"
                                    style={{
                                        maxHeight: "60px",
                                        width: "auto",
                                        objectFit: "contain",
                                    }}
                                />
                            </Box>
                            {/* Başlık */}
                            <Stack
                                spacing={0.5}
                                alignItems="center"
                                justifyContent="center"
                                sx={{
                                    flexGrow: 1,
                                    textAlign: "center",
                                }}
                            >
                                <Typography variant="h5" fontWeight={700} color="primary">
                                    {t("EmergencyWorkOrder")}
                                </Typography>
                            </Stack>
                        </Box>
                    </Grid>

                    {/* 5WHYS ANALYSIS AND COUNTERMEASURES, ROOT CAUSES FAMILIES*/}
                    <Grid container>
                        {/* 5WHYS ANALYSIS */}
                        <FiveWhysAnalysis
                            disableStates={disableStates}
                            hypothesis1_1={hypothesis1_1}
                            handleHypothesis1_1Change={handleHypothesis1_1Change}
                            hasHypothesis1_1Error={hasHypothesis1_1Error}
                            hypothesis1_1ErrorText={hypothesis1_1ErrorText}
                            hypothesis1_2={hypothesis1_2}
                            setHypothesis1_2={setHypothesis1_2}
                            hypothesis1_3={hypothesis1_3}
                            setHypothesis1_3={setHypothesis1_3}
                            hypothesis1_4={hypothesis1_4}
                            setHypothesis1_4={setHypothesis1_4}
                            hypothesis2_1={hypothesis2_1}
                            setHypothesis2_1={setHypothesis2_1}
                            hypothesis2_2={hypothesis2_2}
                            setHypothesis2_2={setHypothesis2_2}
                            hypothesis2_3={hypothesis2_3}
                            setHypothesis2_3={setHypothesis2_3}
                            hypothesis2_4={hypothesis2_4}
                            setHypothesis2_4={setHypothesis2_4}
                            hypothesis3_1={hypothesis2_1}
                            setHypothesis3_1={setHypothesis3_1}
                            hypothesis3_2={hypothesis3_2}
                            setHypothesis3_2={setHypothesis3_2}
                            hypothesis3_3={hypothesis3_3}
                            setHypothesis3_3={setHypothesis3_3}
                            hypothesis3_4={hypothesis3_4}
                            setHypothesis3_4={setHypothesis3_4}
                            hypothesis4_1={hypothesis4_1}
                            setHypothesis4_1={setHypothesis4_1}
                            hypothesis4_2={hypothesis4_2}
                            setHypothesis4_2={setHypothesis4_2}
                            hypothesis4_3={hypothesis4_3}
                            setHypothesis4_3={setHypothesis4_3}
                            hypothesis4_4={hypothesis4_4}
                            setHypothesis4_4={setHypothesis4_4}
                            hypothesis5_1={hypothesis5_1}
                            setHypothesis5_1={setHypothesis5_1}
                            hypothesis5_2={hypothesis5_2}
                            setHypothesis5_2={setHypothesis5_2}
                            hypothesis5_3={hypothesis5_3}
                            setHypothesis5_3={setHypothesis5_3}
                            hypothesis5_4={hypothesis5_4}
                            setHypothesis5_4={setHypothesis5_4}
                            a1What={a1What}
                            setA1What={setA1What}
                            a1Who={a1Who}
                            setA1Who={setA1Who}
                            a1When={a1When}
                            setA1When={setA1When}
                            a2What={a2What}
                            setA2What={setA2What}
                            a2Who={a2Who}
                            setA2Who={setA2Who}
                            a2When={a2When}
                            setA2When={setA2When}
                            a3What={a3What}
                            setA3What={setA3What}
                            a3Who={a3Who}
                            setA3Who={setA3Who}
                            a3When={a3When}
                            setA3When={setA3When}
                            a4What={a4What}
                            setA4What={setA4What}
                            a4Who={a4Who}
                            setA4Who={setA4Who}
                            a4When={a4When}
                            setA4When={setA4When}
                            amWhat={amWhat}
                            setAmWhat={setAmWhat}
                            amWho={amWho}
                            setAmWho={setAmWho}
                            amWhen={amWhen}
                            setAmWhen={setAmWhen}
                            ftWhat={ftWhat}
                            setFtWhat={setFtWhat}
                            ftWho={ftWho}
                            setFtWho={setFtWho}
                            ftWhen={ftWhen}
                            setFtWhen={setFtWhen}
                            smWhat={smWhat}
                            setSmWhat={setSmWhat}
                            smWho={smWho}
                            setSmWho={setSmWho}
                            smWhen={smWhen}
                            setSmWhen={setSmWhen}
                            pmWhat={pmWhat}
                            setPmWhat={setPmWhat}
                            pmWho={pmWho}
                            setPmWho={setPmWho}
                            pmWhen={pmWhen}
                            setPmWhen={setPmWhen}
                            drWhat={drWhat}
                            setDrWhat={setDrWhat}
                            drWho={drWho}
                            setDrWho={setDrWho}
                            drWhen={drWhen}
                            setDrWhen={setDrWhen}
                            asWhat={asWhat}
                            setAsWhat={setAsWhat}
                            asWho={asWho}
                            setAsWho={setAsWho}
                            asWhen={asWhen}
                            setAsWhen={setAsWhen}
                            plWhat={plWhat}
                            setPlWhat={setPlWhat}
                            plWho={plWho}
                            setPlWho={setPlWho}
                            plWhen={plWhen}
                            setPlWhen={setPlWhen}
                        />

                        {/* ROOT CAUSES FAMILIES */}
                        <RootCausesFamiliesForm
                            fromPage={fromPage}
                            selectedFailureToRespect={selectedFailureToRespect}
                            selectedLackOfMaintenance={selectedLackOfMaintenance}
                            selectedInsufficientSkills={selectedInsufficientSkills}
                            selectedDesignWeaknesses={selectedDesignWeaknesses}
                            selectedExternalInfluences={selectedExternalInfluences}
                            selectedLackOfCondition={selectedLackOfCondition}
                            handleLackOfConditionChaged={handleLackOfConditionChaged}
                            lackOfBasicConditions={lackOfBasicConditions}
                            handleFailuretoRespectChaged={handleFailuretoRespectChaged}
                            failureToRespect={failureToRespect}
                            handleLackOfMaintenanceChaged={handleLackOfMaintenanceChaged}
                            lackOfMaintenance={lackOfMaintenance}
                            handleInsufficientSkillsChaged={handleInsufficientSkillsChaged}
                            insufficientSkills={insufficientSkills}
                            handleDesignWeaknessesChaged={handleDesignWeaknessesChaged}
                            designWeaknesses={designWeaknesses}
                            handleExternalInfluencesChaged={handleExternalInfluencesChaged}
                            externalInfluences={externalInfluences}
                        />

                        <Footer
                            handleExecutedTechnicianChange={handleExecutedTechnicianChange}
                            techData={techData}
                            disableStates={disableStates}
                            executedTechnicianName={executedTechnicianName}
                            hasExecutedError={hasExecutedError}
                            executedErrorText={executedErrorText}
                            handleVerifiedTechnicianChange={handleVerifiedTechnicianChange}
                            verifiedTechnicianName={verifiedTechnicianName}
                            hasVerifiedError={hasVerifiedError}
                            verifiedErrorText={verifiedErrorText}
                            hasSignatureError={hasSignatureError}
                            signature={signature}
                            handleSignatureChanged={handleSignatureChanged}
                            signatureErrorText={signatureErrorText}
                            hasClosureDateError={hasClosureDateError}
                            closureDateErrorText={closureDateErrorText}
                            closureDate={closureDate}
                            handleClosureDateChange={handleClosureDateChange}
                        />
                    </Grid>
                </Paper>

                <Buttons
                    isSaveDisable={isSaveDisable}
                    HandleEwoSave={HandleEwoSave}
                    isCancelDisable={isCancelDisable}
                    BackToBreakdownListPage={BackToBreakdownListPage}
                    componentRef={componentRef}
                    pageStyle={pageStyle}
                    isOperatorDisable={isOperatorDisable}
                    HandleEwoSaveAsOperator={HandleEwoSaveAsOperator}
                />
            </div>
        </Container>
    );
}
